// extracted by mini-css-extract-plugin
module.exports = {"carouselSlidesContainer":"TopPicksCarousel_carouselSlidesContainer__exKil","carouselButtons":"TopPicksCarousel_carouselButtons__rZW4C"};